var render, staticRenderFns
import script from "./commonData.vue?vue&type=script&lang=js"
export * from "./commonData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e3631b7')) {
      api.createRecord('1e3631b7', component.options)
    } else {
      api.reload('1e3631b7', component.options)
    }
    
  }
}
component.options.__file = "src/components/develop/commonData.vue"
export default component.exports